import * as React from 'react';

import {FeatureGateModalWrapper} from './feature-gate-modal-wrapper';

type Props = {
    onClose: () => void;
    isOpen: boolean;
};
export function EmailFeatureGateModal(props: Props) {
    return (
        <FeatureGateModalWrapper
            isOpen={props.isOpen}
            title='Automate your email outreach with personal email sequences'
            description='Automatically send tailored emails as leads progress through your sales pipeline.'
            bullets={[
                'Write a sequence of messages which will automatically be sent by Nutshell, as if you sent them personally.',
                'Send personalized emails automatically as leads progress through your sales pipeline.',
                'Save time on manual follow-ups and focus on nurturing valuable relationships.',
                'Track email performance and gain insights to refine your outreach strategy.',
            ]}
            feature='automatedEmails'
            onClose={props.onClose}
        />
    );
}
